import React from 'react';
import "./Styles/AskModal.css";

export const AskModal = ({ok, cancel, register, labelBtn, continueView,  portal_label_access, portal_label_return, fontParam
}) => {

    return (
        <>
         <style jsx>{`
          * {
              font-family: ${fontParam ? fontParam : 'system-ui'};
          }
      `}</style>
            <div className="AskContainer">
                <div className="card AskCard">
                    <div className="card-body">
                        <h5>¿Volver a promociones?</h5>
                    </div>
                    <div className="card-footer" style={{background: "#fff", borderTop: "0px"}}>
                        <div className="AskFooter" style={{
                            flexDirection:  "column",
                        }}>
                            <button className="AskBtn" onClick={() => cancel()}>{portal_label_return}</button>
                            <button className="AskBtn" onClick={() => ok()}>{portal_label_access}</button>
                            {
                                continueView && <button className="AskBtn" onClick={() => continueView()}>Continuar viendo</button>
                            }
                            {
                                register &&  <button className="AskBtn" onClick={() => register()}>{labelBtn ? labelBtn : "Quiero Solcitar Credito"}</button>

                            }
                        </div>
                    </div>
                </div>
            </div>
        
        </>
    )
}
